import { memo } from "react"
import { BookFlightFormValues } from "../../model"
import { useFormContext } from "react-hook-form"
import { ErrorFieldWrapper } from "../error-field-wrapper"

export const ContactInfo = memo(() => {
    const {
        watch,
        register,
        formState: {
            errors
        }
    } = useFormContext<BookFlightFormValues>()

    const travellers = watch('travellers')

    if (!travellers.length) return null

    return (
        <div className="bg-white rounded-3xl p-4">
            <div className="text-lg font-bold mb-3">Контактная информация</div>
            <div className="flex flex-col gap-3 mb-3">
                <div className="md:col-span-4">
                    <label htmlFor={`phone`} className="block text-sm font-medium text-gray-700 mb-1">
                        Телефон *
                    </label>
                    <ErrorFieldWrapper error={errors['phone']?.message}>
                        <input
                            {...register(`phone`)}
                            id={`phone`}
                            placeholder="Фамилия"
                            type="text"
                            className={`rounded-lg px-3 py-4 w-full focus:bg-white transition border bg-slate-50 placeholder:text-zinc-400 ${errors['phone']?.message
                                ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200'
                                : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200'
                            }`}
                        />
                    </ErrorFieldWrapper>
                </div>
            </div>
        </div>
    )
})